import { ReactNode } from 'react'

import { cn } from '@/lib/misc/Utils'

export type PageShellVariant = 'page' | 'app'

const variants: Record<PageShellVariant, string> = {
  page: 'page-shell pt-8 pb-20',
  app: 'page-shell py-4 flex min-h-0 flex-1 flex-col',
}

const PageShell = ({
  children,
  className,
  variant = 'page',
  as: Element = 'div',
}: {
  children: ReactNode
  className?: string
  variant?: PageShellVariant
  as?: 'div' | 'section'
}) => <Element className={cn(variants[variant], className)}>{children}</Element>

export default PageShell
